import React, { useEffect, useState } from "react";
import TestIllustration from "../../assets/Icons/labimage.svg";
import home from "../../assets/Icons/Home.svg";
import center from "../../assets/Icons/Vector.svg";
import blood from "../../assets/Icons/syringe.svg";
import notes from "../../assets/Icons/hour.svg";
import required from "../../assets/Icons/requred.svg";
import check from "../../assets/Icons/fact_check.svg";
import { message, Tooltip } from "antd";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import {
  createCartOrderDtlItem,
  createCartOrderHdrItem,
  getCurrentTime,
} from "../../Shared/CartHelper";

function LabTestCard({ test, deliverable, address, patientMembershipDet }) {
  const [isTestThereInCart, setIsTestThereInCart] = useState(false);
  const dispatch = useDispatch();
  const { cartData } = useSelector((state) => state.cart);
  const { patientData } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!cartData) return;
    const { cartOrderHdr } = cartData;
    const labData = cartOrderHdr?.find((item) => item.orderType === "LAB");
    if (labData) {
      const labItems = labData?.cartOrderDtl;
      if (labItems && labItems?.length !== 0) {
        const isLabTestThereInCart = labItems?.find(
          (item) => item.orderCode === test.testCode,
        );
        if (isLabTestThereInCart) {
          setIsTestThereInCart(true);
        }
      }
    }
  }, [cartData]);

  const calculateDiscountedPrice = (labTest, patientMembershipDet) => {
    if (!patientMembershipDet) return labTest?.listPrice;

    const membershipObj = patientMembershipDet.find(
      (m) => m.serviceCategory === labTest?.testType.toUpperCase(),
    );

    const currentPrice = labTest?.listPrice || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    const finalMedPrice = currentPrice - discountAmount;
    return finalMedPrice?.toFixed(2);
  };

  const calculateDiscountAmount = (labTest, patientMembershipDet) => {
    if (!patientMembershipDet) return 0;
    const membershipObj = patientMembershipDet.find(
      (m) => m.serviceCategory === labTest?.testType.toUpperCase(),
    );

    const currentPrice = labTest?.listPrice || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    return discountAmount;
  };

  const handleAddToCart = async ({ itemObj, type }) => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (!deliverable) {
      message.error(
        "Lab service is not available at your location. Please enter pincode / try another pincode.",
      );
      return;
    }

    if (!patientData) {
      message.error("Please login as a patient");
      return;
    }

    if (!itemObj) return;

    if (!address) {
      message.error("Please select/add your delivery address.");
      return;
    }

    const now = getCurrentTime();
    const existingCartId = cartData?.cartId;
    const cartHdrs = [...(cartData?.cartOrderHdr || [])];
    const itemCode = itemObj.testCode;
    const itemName = itemObj.testName;
    const itemCategory = itemObj?.category || itemObj?.testType?.toUpperCase();
    const vendorId = itemObj.labCode;
    const price = parseFloat(itemObj.listPrice || 0);

    const existingHdr = cartHdrs.find((hdr) => hdr.orderType === type);
    let payload;

    if (!existingCartId) {
      const dtlItem = createCartOrderDtlItem({
        item: {
          code: itemCode,
          name: itemName,
          labCategory: itemCategory,
          price,
          vendorId,
        },
        type,
        patientId: patientData.patientId,
        user: patientData,
      });

      payload = {
        cartOrderHdr: [
          createCartOrderHdrItem({
            Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
            dtlItem,
            account: address,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        ],
        cartType: 1,
        patientId: patientData.patientId,
        paymentType: "",
        status: 1,
      };
      payload.cartOrderHdr[0].labCategory = "External Lab Test";

      let grandTotalAmount = payload?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...payload,
        totalAmount: grandTotalAmount,
      };
    } else {
      const newHdrs = cartHdrs.map((hdr) => {
        if (hdr.orderType !== type) return hdr;

        const existingItem = hdr.cartOrderDtl.find(
          (i) => i.orderCode === itemCode,
        );
        console.log(existingItem, " testing exis ", itemCode, itemObj);
        let updatedDtl = [...hdr.cartOrderDtl];
        if (existingItem) {
          updatedDtl = updatedDtl.map((i) =>
            i.orderCode === itemCode
              ? {
                  ...i,
                  quantity: i.quantity + 1,
                  amount: (i.quantity + 1) * i.unitPrice,
                  paidAmount: (i.quantity + 1) * i.unitPrice,
                  modifiedDate: now,
                  orderState: "U",
                }
              : i,
          );
        } else {
          const newDtlItem = createCartOrderDtlItem({
            item: {
              code: itemCode,
              name: itemName,
              labCategory: itemCategory,
              price,
              vendorId,
            },
            type,
            patientId: patientData.patientId,
            user: patientData,
            cartId: existingCartId,
          });
          updatedDtl.push(newDtlItem);
        }

        const totalAmt = updatedDtl.reduce(
          (sum, i) => sum + Number(i.amount),
          0,
        );
        const totalPaid = updatedDtl.reduce(
          (sum, i) => sum + Number(i.paidAmount),
          0,
        );

        return {
          ...hdr,
          cartOrderDtl: updatedDtl,
          amount: Number(parseFloat(totalAmt).toFixed(2)),
          paidAmount: Number(parseFloat(totalPaid).toFixed(2)),
          modifiedDate: now,
        };
      });

      if (!existingHdr) {
        const dtlItem = createCartOrderDtlItem({
          item: {
            code: itemCode,
            name: itemName,
            labCategory: itemCategory,
            price,
            vendorId,
          },
          type,
          patientId: patientData.patientId,
          user: patientData,
          cartId: existingCartId,
        });

        const cartHdrObject = createCartOrderHdrItem({
          Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
          dtlItem,
          account: address,
          user: patientData,
          patientId: patientData.patientId,
          type,
        });
        cartHdrObject.labCategory = "External Lab Test";
        newHdrs.push(cartHdrObject);
      }

      let grandTotalAmount = newHdrs?.reduce((sum, order) => {
        return sum + (Number(order?.paidAmount) || 0);
      }, 0);

      payload = {
        ...cartData,
        cartId: existingCartId,
        cartOrderHdr: newHdrs,
        modifiedDate: now,
        totalAmount: grandTotalAmount,
      };
    }

    try {
      const updatedCart = await dispatch(AddtoCart(payload));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      message.success("LabTest added to cart successfully.");
    } catch (e) {
      console.log(e);
    }
  };

  const handleLabDet = () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (deliverable) {
      navigate(APP_ROUTES.LABTESTDETAILS, { state: { labTest: test } });
    } else {
      message.error(
        "Lab service is not available at your location. Please enter pincode / try another pincode.",
      );
    }
  };

  return (
    <>
      <div
        key={test.id}
        className="w-[70%] lg:w-[65%] sm:w-full mx-auto bg-white border border-gray-100 rounded-xl p-4 flex gap-4 hover:shadow-xl hover:border-[#189FAA]/30 transition-all duration-300 cursor-pointer group mb-2"
        onClick={handleLabDet}
      >
        <div className="flex sm:flex-col w-full justify-between items-start">
          <div className="flex sm:flex-col gap-4 flex-1">
            <div className="bg-gradient-to-br from-[#F5FEFF] to-[#E6F9FB] rounded-lg flex justify-center items-center w-20 h-20 shadow-sm border border-[#189FAA]/10 group-hover:scale-105 transition-transform duration-300">
              <img src={TestIllustration} alt="" className="w-12 h-12 object-contain" />
            </div>
            <div className="flex-1">
              <h4 className="font-sans font-bold text-base text-gray-800 group-hover:text-[#189FAA] transition-colors leading-tight">
                <Tooltip title={test.testDisplayName}>
                  {test.testDisplayName && test.testDisplayName.length > 50
                    ? `${test.testDisplayName.slice(0, 50)}...`
                    : test.testDisplayName}
                </Tooltip>
              </h4>
              
              <div className="flex flex-wrap gap-2 mt-2 items-center">
                <span className="bg-[#189FAA]/10 text-[#189FAA] px-2 py-0.5 rounded-full text-[10px] font-bold font-sans">
                  {test.noOfTestIncluded} Tests
                </span>
                {test.home && (
                  <div className="flex gap-1 items-center bg-blue-50 px-2 py-0.5 rounded-full border border-blue-100">
                    <img src={home} alt="" className="w-3 h-3" />
                    <p className="text-[10px] font-sans font-bold text-blue-600 uppercase tracking-wider">Home</p>
                  </div>
                )}
                {test.center && (
                  <div className="flex gap-1 items-center bg-purple-50 px-2 py-0.5 rounded-full border border-purple-100">
                    <img src={center} alt="" className="w-3 h-3" />
                    <p className="text-[10px] font-sans font-bold text-purple-600 uppercase tracking-wider">Lab</p>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-4 p-2 bg-gray-50/50 rounded-lg border border-gray-100">
                <div className="flex gap-2 items-center">
                  <div className="bg-white p-1 rounded shadow-sm">
                    <img src={blood} alt="" className="w-3.5 h-3.5" />
                  </div>
                  <div>
                    <p className="text-[9px] text-gray-400 uppercase font-bold">Specimen</p>
                    <p className="text-[11px] font-sans font-bold text-gray-700">{test.specimen || "N/A"}</p>
                  </div>
                </div>
                <div className="flex gap-2 items-center">
                  <div className="bg-white p-1 rounded shadow-sm">
                    <img src={notes} alt="" className="w-3.5 h-3.5" />
                  </div>
                  <div>
                    <p className="text-[9px] text-gray-400 uppercase font-bold">TAT</p>
                    <p className="text-[11px] font-sans font-bold text-gray-700">{test.tat || "N/A"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="w-52 sm:w-full flex flex-col items-end justify-between self-stretch pl-4 border-l border-gray-100 sm:border-l-0 sm:border-t sm:pl-0 sm:pt-3 sm:mt-3">
            <div className="text-right w-full mb-3">
              {patientMembershipDet ? (
                <div className="flex flex-col items-end">
                  <div className="flex items-baseline gap-1.5">
                    <span className="text-xl sm:text-sm font-black text-gray-900 font-sans">
                      ₹{calculateDiscountedPrice(test, patientMembershipDet)}
                    </span>
                    <span className="text-[11px] line-through text-gray-400">
                      ₹{test?.listPrice}
                    </span>
                  </div>
                  <div className="bg-green-100 text-green-700 text-[9px] font-bold px-1.5 py-0.5 rounded mt-0.5 uppercase tracking-tight">
                    Save ₹{calculateDiscountAmount(test, patientMembershipDet)}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-end">
                  <p className="text-[9px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Price</p>
                  <p className="text-xl sm:text-sm font-black text-gray-900 font-sans">
                    ₹{test.listPrice}/-
                  </p>
                </div>
              )}
            </div>
            
            <button
              disabled={isTestThereInCart}
              className={`w-full py-2 px-4 font-sans font-bold text-[13px] rounded-lg transition-all duration-300 shadow active:scale-95 ${
                isTestThereInCart 
                ? "bg-green-500 text-white cursor-default shadow-green-100" 
                : "bg-gradient-to-r from-[#189FAA] to-[#14838d] text-white hover:shadow-md hover:-translate-y-0.5"
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart({
                  itemObj: test,
                  type: "LAB",
                });
              }}
            >
              {isTestThereInCart ? (
                <span className="flex items-center justify-center gap-1.5">
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                  Added
                </span>
              ) : "Add to Cart"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LabTestCard;
